import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const syllabusItems = [
  // { classLabel: "LKG", fileName: "syllabus-ukg_pt-1.pdf" },
  // { classLabel: "UKG", fileName: "syllabus-lkg_pt-1.pdf" },
  // { classLabel: "Class - I", fileName: "syllabus-class1_pt-1.pdf" },
  // { classLabel: "Class - II", fileName: "syllabus-class2_pt-1.pdf" },
  { classLabel: "Class - III", fileName: "pt2-cl-3.pdf" },
  { classLabel: "Class - IV", fileName: "pt2-cl-4.pdf" },
  { classLabel: "Class - V", fileName: "pt2-cl-5.pdf" },
  { classLabel: "Class - VI", fileName: "pt2-cl-6.pdf" },
  { classLabel: "Class - VII", fileName: "pt2-cl-7.pdf" },
  { classLabel: "Class - VIII", fileName: "pt2-cl-8.pdf" },
  { classLabel: "Class - IX", fileName: "pt2-cl-9.pdf" },
  { classLabel: "Class - X", fileName: "pt2-cl-10.pdf" },
  { classLabel: "Class - XI", fileName: "pt2-cl-11.pdf" },
];

function SyllabusPT1() {
  useEffect(() => {
    document.title =
      "Syllabus PT-2 - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus PT 2</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Syllabus - PT 2</h1>
            </div>
          </div>

          <div className="row">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/${item.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SyllabusPT1;
